import { useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { t } from 'i18next';

import { useNewFilters } from 'hooks/useFilters';
import { DocumentType } from 'support/types';
import { PropertyFilter, PropertyFilterType } from 'support/types/filters';

export enum PriceCatalogsFilterKeys {
  messageType = 'message_type',
  partnerName = 'partner_name',
  lastRequestStatus = 'last_request_status',
}

export const usePriceCatalogsFilters = () => {
  const [defaultConfig] = useState(() => getDefaultFilterConfig());
  const { filterValues, filters, updateFilters, clearAllFilters } = useNewFilters(defaultConfig, 'price-catalogs');

  return {
    filterValues,
    filters,
    updateFilters,
    clearAllFilters,
  };
};

const getDefaultFilterConfig = (): Array<PropertyFilter> => [
  {
    key: PriceCatalogsFilterKeys.partnerName,
    type: PropertyFilterType.search,
    placeholder: t('priceCatalogs:partnerList.filters.search.label'),
    value: '',
  },
  {
    key: PriceCatalogsFilterKeys.lastRequestStatus,
    type: PropertyFilterType.dropdown,
    label: t('priceCatalogs:partnerList.filters.lastRequestStatus.label'),
    Icon: CheckCircleIcon,
    value: '',
    dropDownOptions: {
      dropdownValues: [
        { label: t('priceCatalogs:lastRequestStatus.AWAITING_SUBMISSION'), value: 'AWAITING_SUBMISSION' },
        { label: t('priceCatalogs:lastRequestStatus.CATALOG_RECEIVED'), value: 'CATALOG_RECEIVED' },
        { label: t('priceCatalogs:lastRequestStatus.NO_RESPONSE'), value: 'NO_RESPONSE' },
      ],
      defaultToFirstValue: false,
      multiple: false,
    },
  },
  {
    key: PriceCatalogsFilterKeys.messageType,
    type: PropertyFilterType.hidden,
    value: DocumentType.productCatalog,
  },
];
